import componentRegistry from '../registry.js';
import { isUserAuthenticated } from '../../configuration/Configuration.js';
import overlay from '../overlay/index.js';
import sendReviewFeedback from '../../scripts/api/reviews/sendFeedback.js';

/** Send review feedback */
export default class ProductReviewFeedbackButton {
  el;

  constructor({ el }) {
    this.el = el;
    el.addEventListener('click', () => this.sendFeedback());
    el.ownerDocument.defaultView.addEventListener('productreviewfeedback', ({ detail: { review } }) => {
      if (review === this.el.dataset.review) {
        this.el.disabled = true;
      }
    });
  }

  async sendFeedback() {
    const loader = new overlay();
    if (!isUserAuthenticated) {
      loader.show();
      window.location = this.el.dataset.authHref;
      return;
    }
    try {
      const { review, feedback } = this.el.dataset;
      loader.show();
      const { positiveFeedback, negativeFeedback } = await sendReviewFeedback(review, parseInt(feedback, 10));
      this.el.querySelector('.feedbackCount').innerHTML = feedback === '1' ? positiveFeedback : negativeFeedback;
      this.el.dispatchEvent(
        new CustomEvent('productreviewfeedback', {
          bubbles: true,
          cancelable: true,
          detail: { review, feedback },
        })
      );
    } finally {
      // FIXME show a message to the user in error catch (maintenance, "technical" error, id not found, "already answered")
      loader.hide();
    }
  }
}

componentRegistry.define('js-review-feedback-button', ProductReviewFeedbackButton);
